<template>
    <div class="container">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- International Shopping -->
        <div v-if="user.address" class="row my-5">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row">
                                <dt class="col-lg-9 col-md-8 col-6">
                                    <h3 class="mb-3 text-dark-green nav-settings-head">Intl. Shopping</h3>
                                </dt>
                                <dd class="col-lg-3 col-md-4 col-6 nav-settings-head pt-1 text-center h4">
                                    <strong class="mr-2">OFF</strong>
                                    <i @click.prevent="switchOffIntlShpn" v-if="activeIntlShpn" class="fas fa-toggle-on text-dark-green fa-lg clickable"></i>
                                    <i @click.prevent="switchOnIntlShpn" v-else class="fas fa-toggle-off text-dark fa-lg clickable"></i>
                                    <strong class="ml-2 text-dark-green">ON</strong>
                                </dd>
                                <dd class="col-12"><p>You can buy items from any country internationally simply by selecting the country below.</p></dd>
                            </dl>
                            <dl class="row mb-n3">
                                <dt class="col-sm-3 col-12">Country</dt>
                                <dd class="col-sm-6 col-12">
                                    <select @change="switchOnIntlShpn" v-model="alphaCode" class="custom-select no-lines text-capitalize" style="border-color: #DFDFDF;">
                                        <option selected disabled value="">{{intlCountry}}</option>
                                        <option v-for="(x, i) in theCountries" :key="i" :value="x.alphaCode">{{x.country}}</option>
                                    </select>
                                </dd>
                                <dd class="col-sm-3 col-12"><p><input type="text" readonly :value="intlCurrency" class="form-control no-lines text-uppercase"></p></dd>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- My Location -->
        <div class="row my-5">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row">
                                <dt class="col-lg-10 col-md-8 col-sm-6 col-12">
                                    <h3 class="mb-3 text-dark-green nav-settings-head">Your Location</h3>
                                </dt>
                                <dd class="col-lg-2 col-md-4 col-sm-6 col-12 d-none d-sm-block">
                                    <button @click.prevent="updateMyLocation" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                </dd>
                                <dd class="col-12"><small>Your location, it's visible to you alone! Your shipping address won't be displayed to the public. We care about your privacy.</small></dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-3 col-12">Your Address<span class="text-danger">*</span></dt>
                                <dd class="col-sm-9 col-12">
                                    <p>
                                        <input v-model="address" type="text" :placeholder="neighborhood" class="form-control no-lines text-capitalize">
                                        <small>
                                            Please enter your correct address alone, click the Save Changes button. 
                                            We will auto-fill in your nearest city, state &amp; zipcode if available.
                                        </small>
                                    </p>
                                </dd>
                                
                                <dt class="col-sm-3 col-12">Nearest City</dt>
                                <dd class="col-sm-9 col-12"><p><input type="text" readonly :placeholder="user.lga" class="form-control no-lines text-capitalize"></p></dd>

                                <dt class="col-sm-3 col-12">State</dt>
                                <dd class="col-sm-9 col-12"><p><input type="text" readonly :placeholder="user.state" class="form-control no-lines text-capitalize"></p></dd>
                                
                                <dt class="col-sm-3 col-12">Country</dt>
                                <dd class="col-sm-6 col-12"><p><input type="text" readonly :value="user.country" class="form-control no-lines text-capitalize"></p></dd>
                                <dd class="col-sm-3 col-12"><p><input type="text" readonly :value="user.currency" class="form-control no-lines text-uppercase"></p></dd>
                                
                                <template v-if="user.zipCode">
                                    <dt class="col-sm-3 col-12">Zip Code</dt>
                                    <dd class="col-sm-9 col-12"><p><input v-model="zipCode" type="text" :placeholder="user.zipCode" class="form-control no-lines"></p></dd>
                                </template>
                            </dl>
                            <dl class="row d-sm-none mt-n4">
                                <dd class="col-12">
                                    <hr>
                                    <div class="row">
                                        <div class="col-6">
                                            <router-link :to="{ name: 'profile' }" class="btn btn-light btn-sm bg-white form-control">Go Back</router-link>
                                        </div>
                                        <div class="col-6">
                                            <button @click.prevent="updateMyLocation" class="loadn btn btn-dark-green btn-sm form-control">Save Changes</button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Location",
    data() {
        return {
            address: '',
            zipCode: '',
            alphaCode: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['updateUsersCountry', 'updateUsersCity', 'updateIntlShopping']),
        updateMyLocation(){
            this.color = "danger"
            if(this.address === ''){ this.msg = "Your address is required!"; return }
            if(this.address.length < 4){ this.msg = "Your full address is required!"; return }
            let userObj = {
                userId: this.user._id,
                city: this.address.toLowerCase()
            }
            this.updateUsersCity(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Your approx. location was updated successfully!"
                this.address = ""
            }).catch((e) => {
                this.msg = "Updating your approx. location failed, try again."
            })
        },
        switchOnIntlShpn(){
            this.color = "danger"
            if(this.alphaCode === ''){ this.msg = "Select the country you wish to shop from"; return }
            if(this.alphaCode === this.user.alphaCode){ this.msg = "Select a country outside of yours or toggle off"; return }
            let userObj = {
                userId: this.user._id,
                alphaCode: this.alphaCode
            }
            this.updateIntlShopping(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Intl. shopping switched on successfully. You are now shopping internationally!"
            }).catch((e) => {
                this.msg = "Switching country failed, try again."
            })
        },
        switchOffIntlShpn(){
            this.color = "danger"
            let userObj = {
                userId: this.user._id,
                alphaCode: this.user.alphaCode
            }
            this.updateIntlShopping(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Intl. shopping switched off successfully. You are now shopping locally!"
            }).catch((e) => {
                this.msg = "Switching country failed, try again."
            })
        },
        updateMyCountry(){
            let userObj = {
                userId: this.user._id,
                alphaCode: this.user.alphaCode
            }
            this.updateUsersCountry(userObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'setCountries', 'authenticated']),
        theCountries(){
            if(this.setCountries && this.setCountries.length){
                return this.setCountries
            }
            return []
        },
        neighborhood() {
            if(this.user.address){
                return this.user.address
            }
            else if(this.user.neighborhood){
                return this.user.neighborhood
            }
            else {
                return this.user.city
            }
        },
        intlCountry() {
            if(this.user.intlShpCountry){
                return this.user.intlShpCountry
            }
            return 'select country'
        },
        intlCurrency() {
            if(this.user.intlShpCurrency){
                return this.user.intlShpCurrency
            }
            return 'currency'
        },
        activeIntlShpn() {
            if(!this.user.intlShpAlphaCode){
                return false
            }
            if(this.user.intlShpAlphaCode === this.user.alphaCode){
                return false
            }
            return true
        }
    },
    mounted() {
        if(this.user && !this.user.countryConfirmed){
            this.updateMyCountry()
        }
    }
}
</script>